
/**
 * Login section .js-login
 */

import '../complib/polyfillClosest';
import { scrollTo } from '../ui/scrollTo';
import { getFocusableChildren, setTabIndex } from '../util/focusable';
class LoginSection {
	constructor(elem) {
		// console.info('Initializing LoginSection', elem);
		this.elem = elem;
		if (!this.elem) {
			return;
		}

		// Login
		this.loginSection = elem.querySelector('.js-club-login');
		this.loginForm = this.loginSection.querySelector('.form-login-form');
		this.emailInput = this.loginForm.querySelector('input[name="email"]');
		this.loginChildren = getFocusableChildren(this.loginSection);

		// Register
		this.registerSection = elem.querySelector('.js-club-registration');
		this.registerLink = elem.querySelectorAll('.js-toggle-register');
		this.registerChildren = getFocusableChildren(this.registerSection);

		this.initEvents();
		if (this.elem.classList.contains('b2b-join-initialized')) {
			// If this is a B2B join, open the register section directly
			this.openRegister('company');
		}
	}

	scrollTop() {
		const popup = this.elem.closest('.js-overlay-content');
		if (popup) {
			scrollTo(popup, 0, 200);
		}
	}

	hideRegister() {
		this.registerSection.classList.add('u-hidden');
		this.loginSection.classList.remove('u-hidden');

		setTabIndex(this.registerChildren, -1);
		setTabIndex(this.loginChildren, 0);

		this.scrollTop();
	}

	openRegister(triggerId = null) {
		this.loginSection.classList.add('u-hidden');
		this.registerSection.classList.remove('u-hidden');
		// this.registerSection is a HTML div element containing the form
		// Search class m-form__heading-title and mutate title based on triggerId
		const title = this.registerSection.querySelector('.m-form__heading-title');
		if (title && title.innerHTML && triggerId === 'company') {
			title.innerHTML = title.innerHTML.replace('clubiin', 'yritysclubiin');
			this.registerSection.querySelectorAll('.club-only').forEach((el) => {
				el.classList.add('u-hidden');
			});
			this.registerSection.querySelectorAll('.company-only').forEach((el) => {
				el.classList.remove('u-hidden');
			});
		} else if(title && title.innerHTML && triggerId === 'club') {
			title.innerHTML = title.innerHTML.replace('yritysclubiin', 'clubiin');
			this.registerSection.querySelectorAll('.company-only').forEach((el) => {
				el.classList.add('u-hidden');
			});
			this.registerSection.querySelectorAll('.club-only').forEach((el) => {
				el.classList.remove('u-hidden');
			});
		}

		setTabIndex(this.loginChildren, -1);
		setTabIndex(this.registerChildren, 0);

		this.scrollTop();
	}

	hideResetPassword() {
		// Note: the old password reset form this concerned no longer exists.
		// This function is left just in case there's a login form that's initially hidden.
		this.loginForm.classList.remove('u-hidden');
		setTabIndex(this.loginChildren, 0);
		this.scrollTop();
	}

	initEvents() {
		const _context = this;

		// Register form
		if (this.registerSection && this.registerLink.length) {
			for (let trigger of this.registerLink) {
				// trigger is a button HTML element
				const triggerId = trigger.getAttribute('id');
				trigger.addEventListener('click', (e) => {
					if (_context.registerSection.classList.contains('u-hidden')) {
						_context.openRegister(triggerId);
					} else {
						_context.hideRegister();
					}
				});
			}
		}

		// Init tab indexes
		setTabIndex(this.registerChildren, -1);
	}
}

export { LoginSection };
